/**
 * Error code enum
 */
export enum ErrorCodeEnum {
	/**
	 * Success
	 */
	Success = 0,
}
